import React from 'react';
import useUser from '../hooks/useUser';
import ServerNotifications from './server/Notifications';

const Notifications = () => {
    const { userRole } = useUser();
    // Get role from localStorage as fallback
    const role = userRole || localStorage.getItem('role') || '';
    const roleLower = role?.toLowerCase() || '';
    // Render based on role

    return <ServerNotifications />;
};
export default Notifications;
